import { createFileRoute } from '@tanstack/react-router'
import CalendarPage from '@/features/calendar/components/CalendarPage'
import { AutoBreadcrumb } from '@/components/ui/auto-breadcrumb'

export const Route = createFileRoute('/_authenticated/calendar')({
  component: CalendarPageRoute,
})

function CalendarPageRoute() {
  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6">
      <AutoBreadcrumb />
      <CalendarPage />
    </div>
  )
}
